import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas, faPenToSquare, faRotate, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function Products() {
  const [data, setData] = useState(false);
  const [data1, setData1] = useState(false);
  const [errors, setErrors] = useState(false);
  const [productCategory, setProductCategory] = useState(false);
  const [subCategory, setSubCategory] = useState(false);
  const [base64, setBase64] = useState('');
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(0);
  const [editData, setEditData] = useState(false);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );
  const handleClose = () => {
    setShowModal(false);
    setEditData(false);
  };
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const readers = selectedFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          resolve({
            name: file.name,
            type: file.type,
            size: file.size,
            base64: reader.result,
          });
        };

        reader.onerror = () => {
          reject(new Error(`Failed to read file: ${file.name}`));
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(readers)
      .then((base64Files) => {
        setBase64(base64Files); // Assuming setBase64Files is your state setter
      })
      .catch((error) => {
        console.error("Error reading files:", error);
      });
  };
  const editCategory = async (index, categoryId) => {
    const response = await axios.post("/history/getProductSubCategoryByCategoryId", { categoryId });
    const { status, data } = response.data;
    if (status) {
      setSubCategory(data);
    }
    setEditIndex(index);
    setEditData(true);
  };
  const changeData = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name == "categoryId") {
      const response = await axios.post("/history/getProductSubCategoryByCategoryId", { categoryId: value });
      const { status, data } = response.data;
      if (status) {
        setSubCategory(data);
      }
    }
    setData1({ ...data1, data: { ...data1.data, [editIndex]: { ...data1.data[editIndex], [name]: value } } });
  };
  const deleteCategory = async (id) => {
    try {
      const response = await axios.post('/product/deleteProduct', { id });
      const { status, message } = response.data;
      if (status) {
        setRefresh(!refresh);
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        jsonData["images"] = base64;
        const response = await axios.post('/product/addProduct', jsonData);
        const { status, message } = response.data;
        if (status) {
          setRefresh(!refresh);
          setShowModal(false);
        }
        else {
          setShowModal(false);
        }
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  const updateSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        jsonData["images"] = base64;
        const response = await axios.post('/product/updateProduct', { ...jsonData, id: data1 && data1.data[editIndex]._id });
        const { status, message } = response.data;
        if (status) {
          setRefresh(!refresh);
          handleClose();
        }
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
    };
    getData(rechargeData);
  };

  const getData = async (requestData = {}) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/getProduct", requestData);
      const { status, data, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setData1(response.data);
        setPageData({ first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getData1 = async () => {
    try {
      setLoading(true);
      const response = await axios.post("/product/getProductCategory");
      const { status, data } = response.data;
      if (status) {
        setProductCategory(data);
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [refresh]);

  useEffect(() => {
    getData1();
  }, []);

  const ChangeStatus = async (options, e) => {
    options.editorCallback(e.target.value)
    try {
      const response = await axios.post('/product/changeProductStatus', { id: options.rowData._id, status: e.target.value });
      const { status, message } = response.data;
      if (status) {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    if (newValue.trim().length > 0) rowData[field] = newValue;
    else event.preventDefault();
  };

  const cellEditor = (options) => {
    return (
      <select value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="1">Active</option>
        <option value="0">InActive</option>
      </select>
    );
  };

  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  const handleDelete = async (e, productId, imageIndex) => {
    const response = await axios.post('/product/deleteImage', { productId, imageIndex });
    const { status, message } = response.data;
    if (status) {
      const deleteId = e.target.getAttribute('delete_id');
      document.getElementById(deleteId).style.display = "none";
      toast(message);
    }
  };

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Products
                {/* Button that triggers the modal */}
                <Button className="float-right" variant="primary" onClick={(e) => setShowModal(true)}>
                  Add
                </Button>
              </h4>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Products
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="sku"
                        header="Sku"
                        sortable
                        body={(rowData) => <span data-label="Sku">{rowData?.sku}</span>}
                      />
                      <Column
                        field="productName"
                        header="ProductName"
                        sortable
                        body={(rowData) => <span data-label="ProductName">{rowData?.productName}</span>}
                      />
                      <Column
                        field="price"
                        header="Price"
                        sortable
                        body={(rowData) => <span data-label="Price">र {rowData?.price}</span>}
                      />
                      <Column
                        field="discountInPercent"
                        header="DiscountInPercent"
                        sortable
                        body={(rowData) => <span data-label="DiscountInPercent">{rowData?.discountInPercent || 0}%</span>}
                      />
                      <Column
                        field="discountedPrice"
                        header="DiscountedPrice"
                        sortable
                        body={(rowData) => <span data-label="DiscountedPrice">र {rowData?.price - (rowData?.price * rowData?.discountInPercent) / 100}</span>}
                      />
                      <Column
                        field="categoryName"
                        header="CategoryName"
                        sortable
                        body={(rowData) => <span data-label="CategoryName">{rowData?.categoryId?.categoryName}</span>}
                      />
                      <Column
                        field="subCategoryName"
                        header="SubCategoryName"
                        sortable
                        body={(rowData) => <span data-label="SubCategoryName">{rowData?.subCategoryId?.subCategoryName}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData?.status == "1" ? "Active" : "InActive"}</span>}
                        editor={(options) => cellEditor(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <Link onClick={(e) => editCategory(rowIndex, rowData?.categoryId?._id)}><FontAwesomeIcon icon={faPenToSquare} className="successIcon" title="Edit" /></Link>
                              <Link onClick={(e) => deleteCategory(rowData?._id)}><FontAwesomeIcon icon={fas.faTrash} className="successIcon" title="Delete" /></Link>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  <div class="col-lg-4 col-md-4">
                    <label>SKU</label>
                    <input className="form-control" name="sku" requiredField="true" />
                    <span className="error">{errors && errors?.sku}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Product Name</label>
                    <input className="form-control" name="productName" requiredField="true" />
                    <span className="error">{errors && errors?.productName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Description</label>
                    <input className="form-control" name="description" requiredField="true" />
                    <span className="error">{errors && errors?.description}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Price</label>
                    <input type="number" className="form-control" name="price" requiredField="true" />
                    <span className="error">{errors && errors?.price}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Discount</label>
                    <input type="number" className="form-control" name="discountInPercent" requiredField="true" />
                    <span className="error">{errors && errors?.discountInPercent}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Category Name</label>
                    <select class="form-control" name="categoryId" onChange={changeData} requiredField="true">
                      <option value="">--Select--</option>
                      {
                        productCategory && productCategory.map(c => (
                          <option value={c._id}>{c.categoryName}</option>
                        ))
                      }
                    </select>
                    <span className="error">{errors && errors?.categoryId}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>SubCategory Name</label>
                    <select class="form-control" name="subCategoryId" requiredField="true">
                      <option value="">--Select--</option>
                      {
                        subCategory && subCategory.map(sc => (
                          <option value={sc._id}>{sc.subCategoryName}</option>
                        ))
                      }
                    </select>
                    <span className="error">{errors && errors?.subCategoryId}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Size (Add Size With Comma(Eg: S,M,L))</label>
                    <input className="form-control" name="size" />
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Color (Add Color With Comma(Eg: Yellow, Blue))</label>
                    <input className="form-control" name="color" />
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Upload Images</label>
                    <input type="file" className="form-control" name="images" requiredField="true" multiple onChange={handleFileChange} />
                    <span className="error">{errors && errors?.images}</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={editData} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={updateSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Update Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div class="col-lg-4 col-md-4">
                    <label>SKU</label>
                    <input className="form-control" name="sku" value={data1?.data?.[editIndex]?.sku} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.sku}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Product Name</label>
                    <input className="form-control" name="productName" value={data1?.data?.[editIndex]?.productName} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.productName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Description</label>
                    <input className="form-control" name="description" value={data1?.data?.[editIndex]?.description} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.description}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Price</label>
                    <input type="number" className="form-control" name="price" value={data1?.data?.[editIndex]?.price} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.price}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Discount</label>
                    <input type="number" className="form-control" name="discountInPercent" value={data1?.data?.[editIndex]?.discountInPercent} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.discountInPercent}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Category Name</label>
                    <select class="form-control" name="categoryId" value={data1?.data?.[editIndex]?.categoryId?._id} onChange={changeData} requiredField="true">
                      <option value="">--Select--</option>
                      {
                        productCategory && productCategory.map(c => (
                          <option value={c._id}>{c.categoryName}</option>
                        ))
                      }
                    </select>
                    <span className="error">{errors && errors?.categoryId}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>SubCategory Name</label>
                    <select class="form-control" name="subCategoryId" value={data1?.data?.[editIndex]?.subCategoryId?._id} onChange={changeData} requiredField="true">
                      <option value="">--Select--</option>
                      {
                        subCategory && subCategory.map(sc => (
                          <option value={sc._id}>{sc.subCategoryName}</option>
                        ))
                      }
                    </select>
                    <span className="error">{errors && errors?.subCategoryId}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Size (Add Size With Comma(Eg: S,M,L))</label>
                    <input className="form-control" name="size" value={data1?.data?.[editIndex]?.size} onChange={changeData} />
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Color (Add Color With Comma(Eg: Yellow, Blue))</label>
                    <input className="form-control" name="color" value={data1?.data?.[editIndex]?.color} onChange={changeData} />
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Upload Images</label>
                    <input type="file" className="form-control" name="images" multiple onChange={handleFileChange} />
                    <span className="error">{errors && errors?.images}</span>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <label>Picture</label>
                    <div className="productImg">
                      {
                        data1?.data?.[editIndex]?.images && (data1?.data?.[editIndex]?.images).map((sc, index) => (
                          <div id={`img_${editIndex}_${index}`} className="image-container">
                            <img src={sc} />
                            <button type="button" className="delete-btn" delete_id={`img_${editIndex}_${index}`} onClick={(e) => handleDelete(e, data1?.data?.[editIndex]?._id, index)}>×</button>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Products;
